
import React from "react";
import { useTranslation } from "react-i18next";
import { Popup, Grid, Icon, List, Header, Table, StateCell } from "semantic-ui-react";

export default function DetailDescount(props) {
  const { t } = useTranslation();
  const user = JSON.parse(localStorage.getItem("userInfo"));

  return (
    <>
      <Popup trigger={<span className="text_date_format cursor-pointer">{t('space_description')}<Icon name='info' color='red' size='small' circular/></span>} flowing hoverable>
        <div className="text-[14px]">
          <p>{props.stateSpace.special_discount_description}</p>
        </div>
      </Popup>
    </>
  );
}